export const userLsKey = 'user';

export const latestReadingTimestampKey = '_latestReadingTimestamp';

export const MELPumpTokenName = '__SYSTEM_MELPump';